
export default {
  methods: {
    /**
     * @description: To home page.
     * @param {*}
     * @return {*}
     */
    toSearchPage() {
      this.$router.push(this.localePath('/product/search'))
    },
  },
}
